export const environment = {
  name: 'homologação',
  development: false,
  test: true,
  production: false,
  baseUrl: 'https://app-api-homologa.egtec.com.br/api/v1',
  egtecServicosUrl: 'https://api-servicos-homologa.egtec.app.br/api/v1',
  certificados: 'https://api-certificados-homologa.egtec.app.br/api'
};
